import { withDependencies } from '@wix/thunderbolt-ioc'
import type { BrowserWindow, Experiments } from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol, ExperimentsSymbol } from '@wix/thunderbolt-symbols'
import { links } from '@wix/thunderbolt-commons'

import type { IMpaNavigation } from './types'

export const MpaNavigation = withDependencies(
	[ExperimentsSymbol, BrowserWindowSymbol],
	(experiments: Experiments, browserWindow: BrowserWindow): IMpaNavigation => {
		return {
			isEligible: ({ anchorCompId, anchorDataId, skipHistory } = {}) => {
				return (
					process.env.PACKAGE_NAME !== 'thunderbolt-ds' &&
					!!experiments['specs.thunderbolt.fullPageNavigationSpecificSites'] &&
					!!browserWindow &&
					!anchorCompId &&
					!anchorDataId &&
					!skipHistory
				)
			},
			navigate: (href: string) => {
				if (!browserWindow) {
					return false
				}

				const currentUrl = new URL(browserWindow.location.href)
				const navigableUrl = new URL(href)
				navigableUrl.protocol = currentUrl.protocol
				navigableUrl.href = links.appendInternalQueryParamsToHref(navigableUrl.href, currentUrl)

				if (navigableUrl.href === currentUrl.href) {
					return true
				}

				browserWindow.location.href = navigableUrl.href

				return true
			},
		}
	}
)
